import {
  ISiteVisit,
  SiteVisitQuestionType,
  SiteVisitQuestionCategoryType,
  SiteVisitMapType,
  SelectMode,
} from '../modules/SiteVisit/types';

export const mockSiteVisit: ISiteVisit = {
  title: 'Site Visit for ADU Project',
  // preview: {
  //   id: '1',
  //   isPublish: true,
  //   isPrimary: true,
  //   original: 'https://via.placeholder.com/800x600',
  // },
  // map: {
  //   coordinates: [-121.93937, 37.30746],
  //   address: '1041 Thornton Way, San Jose, California 95128, United States',
  //   city: 'San Jose',
  //   state: 'California',
  //   county: 'Santa Clara County',
  // },
  categories: [
    {
      id: '1',
      title: 'House',
      description: 'Information about the house',
      type: SiteVisitQuestionCategoryType.house,
      icon: 'home',
      questions: [
        {
          id: '1',
          title: 'Distance from back of house to rear fence or property line',
          description:
            'Measure the distance between two points: 1. the point at the back of your house closest to future ADU 2. the point at the nearest rear fence',
          type: SiteVisitQuestionType.map,
          category: SiteVisitQuestionCategoryType.house,
          required: false,
          colors: {
            point: '#d2d5d4', // gray
            line: '#d2d5d4',
            fill: '#d2d5d4',
          },
          mapType: SiteVisitMapType.line,
        },
        {
          id: '2',
          title: 'Any additional structures on the property',
          description: 'Shed, garage, play structures, pool, etc.',
          type: SiteVisitQuestionType.map,
          category: SiteVisitQuestionCategoryType.house,
          required: false,
          colors: {
            point: '#5e57c0',
            line: '#5e57c0',
            fill: '#009da6',
          },
          mapType: SiteVisitMapType.multiple,
        },
        {
          id: '3',
          title: 'Backyard hardscape and landscape',
          description: 'Take a panoramic photo of your backyard space',
          type: SiteVisitQuestionType.photos,
          category: SiteVisitQuestionCategoryType.house,
          required: true,
        },
        {
          id: '9',
          title: "Location of trunks of any medium (Over 15' tall) to large trees",
          description:
            "Mark the locations. Measure circumference of trunks at 4.5' from soil. Write the corresponding cirecumference separated by commas. (inches)",
          type: SiteVisitQuestionType.map,
          category: SiteVisitQuestionCategoryType.landscape,
          required: true,
          colors: {
            point: '#009da6',
            line: '#009da6',
            fill: '#009da6',
          },
          mapType: SiteVisitMapType.multiple,
        },
        {
          id: '4',
          title: 'Architectural Style',
          type: SiteVisitQuestionType.select,
          category: SiteVisitQuestionCategoryType.house,
          required: true,
          mode: SelectMode.single,
          options: ['Spanish', 'Mediterranean', 'Farmhouse', 'Ranch', 'Contemporary', 'Other'],
        },
        {
          id: '5',
          title: 'Roof Material',
          type: SiteVisitQuestionType.select,
          category: SiteVisitQuestionCategoryType.house,
          required: true,
          mode: SelectMode.single,
          options: [
            'Asphalt Composite Shingles',
            'Standing Seam Metal',
            'Metal Shingles',
            'Wood Shingles/Shakes',
            'Clay Tile',
            'Build up Roofing',
            'Membrane',
          ],
        },
        {
          id: '6',
          title: 'Siding',
          type: SiteVisitQuestionType.select,
          category: SiteVisitQuestionCategoryType.house,
          required: true,
          mode: SelectMode.single,
          options: ['Stucco', 'Vinyl', 'Composite', 'Fiber cement', 'Wood', 'Metal', 'Membrane'],
        },
        {
          id: '7',
          title: 'Windows',
          description: 'Color, Material, Manufacturer',
          type: SiteVisitQuestionType.photos,
          category: SiteVisitQuestionCategoryType.house,
          required: true,
        },
        {
          id: '8',
          title: 'Doors',
          description: 'Front entry, patio',
          type: SiteVisitQuestionType.photos,
          category: SiteVisitQuestionCategoryType.house,
          required: true,
        },
      ],
    },
    {
      id: '2',
      title: 'Zoning',
      description: 'Information about the zoning',
      type: SiteVisitQuestionCategoryType.zoning,
      icon: 'environment',
      questions: [
        {
          id: '41',
          title: 'Do you know if this property is in a flood zone?',
          description: 'Enter the flood zone designation (e.g. Flood Zone D)',
          type: SiteVisitQuestionType.text,
          category: SiteVisitQuestionCategoryType.zoning,
          required: true,
          help: 'If you are not sure, check the FEMA Flood Map Service Center:\nhttps://msc.fema.gov/portal/home',
        },
        {
          id: '42',
          title: 'Do you know the fire hazard zoning for this property?',
          description: 'Enter the fire hazard severity zone (e.g. Fire Hazard Zone High)',
          type: SiteVisitQuestionType.text,
          category: SiteVisitQuestionCategoryType.zoning,
          required: true,
          help: 'If you are not sure, check here:\nCalifornia: https://osfm.fire.ca.gov/what-we-do/community-wildfire-preparedness-and-mitigation/fire-hazard-severity-zones',
        },
        {
          id: '43',
          title: 'Is this property in a coastal zone?',
          description: 'Enter the coastal zone designation if applicable',
          type: SiteVisitQuestionType.text,
          category: SiteVisitQuestionCategoryType.zoning,
          required: true,
        },
        {
          id: '44',
          title: 'Is this property part of an HOA (Homeowners Association)?',
          type: SiteVisitQuestionType.select,
          category: SiteVisitQuestionCategoryType.zoning,
          required: true,
          mode: SelectMode.single,
          options: ['Yes', 'No'],
        },
      ],
    },
    {
      id: '3',
      title: 'Power',
      description: 'Information about power connections',
      type: SiteVisitQuestionCategoryType.power,
      icon: 'thunderbolt',
      questions: [
        {
          id: '10',
          title: 'Any power lines running through property',
          description: 'easements, poles, etc',
          type: SiteVisitQuestionType.map,
          category: SiteVisitQuestionCategoryType.power,
          required: false,
          colors: {
            point: '#fb4556',
            line: '#fb4556',
            fill: '#fb4556',
          },
          mapType: SiteVisitMapType.multiple,
        },
        {
          id: '11',
          title: 'Electrical panel',
          description: '',
          type: SiteVisitQuestionType.map,
          category: SiteVisitQuestionCategoryType.power,
          required: false,
          mapType: SiteVisitMapType.single,
          colors: {
            point: '#fb4556',
            line: '#fb4556',
            fill: '#fb4556',
          },
          help: 'Please attach two photos\nPhoto of the full view of the wall where the panel is located.\nPhoto of subpanel.',
        },
        {
          id: '12',
          title: 'Size of electrical meter (Amps)',
          description: '',
          type: SiteVisitQuestionType.photos,
          category: SiteVisitQuestionCategoryType.power,
          required: true,
          help: 'There are several important pieces of information that your job owner can pull from the information found on the face of your electric meter.',
        },
        {
          id: '13',
          title: 'Overall area surrounding the existing main service panel location',
          description: '',
          type: SiteVisitQuestionType.photos,
          category: SiteVisitQuestionCategoryType.power,
          required: true,
          help: 'This photo is one of the most important photos when processing your application. It allows your representative to see the working space in front of the electric panel, the wall space several feet to the left and right of the electric panel, and also any hazards or concerns that may be in close proximity to the electric panel that may cause an issue with keeping the electric panel in the same location.',
        },
        {
          id: '14',
          title: 'Photo of the full view of the wall where the panel is located',
          description: '',
          type: SiteVisitQuestionType.photos,
          category: SiteVisitQuestionCategoryType.power,
          required: true,
          help: 'Photo of the full view of the wall where the panel is located',
        },
        {
          id: '15',
          title: 'Photo of subpanel',
          description: '',
          type: SiteVisitQuestionType.photos,
          category: SiteVisitQuestionCategoryType.power,
          required: true,
          help: 'Photo of subpanel',
        },
        {
          id: '16',
          title: 'Face of electric meter',
          description: 'Take a photo as shown in the example',
          type: SiteVisitQuestionType.photos,
          category: SiteVisitQuestionCategoryType.power,
          required: true,
          help: 'There are several important pieces of information that your job owner can pull from the information found on the face of your electric meter.',
          helpImages: ['/public/images/site-visit/2.png'],
        },
        {
          id: '17',
          title: 'Breaker section of the main service panel',
          description: 'Take a photo as shown in the example',
          type: SiteVisitQuestionType.photos,
          category: SiteVisitQuestionCategoryType.power,
          required: true,
          help: 'This photo is especially important if your application is requesting a "like-for-like" panel replacement. needs to verify what the current maximum amperage rating is for your main service panel. To determine the max rating, will look at either the main breaker or a panel label often found on the lid of the electric panel cover. (Please include a photo of the panel label if still intact because the label is often helpful in determining your existing panel\'s max amperage rating). The photo resolution in these photos are also an important thing to note because if the photos provided are too blurry to verify label information or breaker ratings then the photos will be requested again in a higher resolution (clearer photo).',
          helpImages: ['/public/images/site-visit/3.png'],
        },
        {
          id: '18',
          title: 'Weather head (point of overhead service wire attachment)',
          description: 'Take a photo as shown in the example',
          type: SiteVisitQuestionType.photos,
          category: SiteVisitQuestionCategoryType.power,
          required: true,
          help: "This photo is used to verify where the current service attachment is on the customer's home. It is important to see the service attachment on the home because it affects scheduling due to different factors including accessibility, height from the ground, and location on the home. Depending on the scope of work for your project, it is important to advise your job owner if there will be any change to the location of the service wire attachment on the customer's home.",
          helpImages: ['/public/images/site-visit/4.png'],
        },
        {
          id: '19',
          title: 'Service wire path',
          description:
            'Take a photo as shown in the example. \n If underground connection, please show location of the box that powers your street.',
          type: SiteVisitQuestionType.photos,
          category: SiteVisitQuestionCategoryType.power,
          required: true,
          help: "This photo is used to see what the existing service wire path is for the overhead service coming from the pole to the customer's home. This is used to determine if the wire is crossing over a different property other than the customer the service is serving, if there are any obstructions in the service wire path including vegetation, height of the service wire from the ground, and also to make sure that the existing service wire will still be usable or not for the proposed scope of work. The best practice for taking this photo is standing close to where the service is attached on the customer's home and looking back towards the pole to see the entire path of the service wire. \n If underground connection, please show location of the box that powers your street.",

          helpImages: ['/public/images/site-visit/5.png'],
        },
      ],
    },
    {
      id: '4',
      title: 'Water',
      description: 'Information about water connections',
      type: SiteVisitQuestionCategoryType.water,
      icon: 'deployment-unit',
      questions: [
        {
          id: '20',
          title: 'Main Water line connection',
          description: 'Closest to proposed ADU',
          type: SiteVisitQuestionType.map,
          category: SiteVisitQuestionCategoryType.water,
          required: false,
          colors: {
            point: '#3a50b0',
            line: '#3a50b0',
            fill: '#3a50b0',
          },
          mapType: SiteVisitMapType.single,
        },
        {
          id: '21',
          title: 'Water meter',
          description: 'Mark the location',
          type: SiteVisitQuestionType.map,
          category: SiteVisitQuestionCategoryType.water,
          required: false,
          colors: {
            point: '#3a50b0',
            line: '#3a50b0',
            fill: '#3a50b0',
          },
          mapType: SiteVisitMapType.single,
        },
        {
          id: '22',
          title: 'Face of water meter',
          description: '',
          type: SiteVisitQuestionType.photos,
          category: SiteVisitQuestionCategoryType.water,
          required: true,
        },
        {
          id: '40',
          title: 'Size of water meter',
          description: '',
          type: SiteVisitQuestionType.select,
          category: SiteVisitQuestionCategoryType.sewer,
          required: true,
          mode: SelectMode.single,
          options: ['5/8"', '3/4"', '1"', '1 1/2"', '2"'],
        },
      ],
    },
    {
      id: '5',
      title: 'Sewer',
      description: 'Information about sewer connections',
      type: SiteVisitQuestionCategoryType.sewer,
      icon: 'fall',
      questions: [
        {
          id: '23',
          title: 'Sewer lateral',
          description: 'Optimal connection point for ADU. Comment on the depth and diameter',
          type: SiteVisitQuestionType.map,
          category: SiteVisitQuestionCategoryType.sewer,
          required: true,
          colors: {
            point: '#c78e2f',
            line: '#c78e2f',
            fill: '#c78e2f',
          },
          mapType: SiteVisitMapType.single,
        },
        {
          id: '24',
          title: 'Does the property have a slope?',
          description: '',
          type: SiteVisitQuestionType.select,
          category: SiteVisitQuestionCategoryType.sewer,
          required: true,
          mode: SelectMode.single,
          options: ['Flat', 'Slopes to rear', 'Slopes to front', 'not sure'],
        },
        {
          id: '25',
          title: 'Sewer Cleanout',
          description: 'Note closest to street',
          type: SiteVisitQuestionType.map,
          category: SiteVisitQuestionCategoryType.sewer,
          required: false,
          colors: {
            point: '#fb4556',
            line: '#c78e2f',
            fill: '#c78e2f',
          },
          mapType: SiteVisitMapType.single,
        },
      ],
    },
    {
      id: '6',
      title: 'Hydrant',
      description: 'Information about fire hydrants',
      type: SiteVisitQuestionCategoryType.hydrant,
      icon: 'fire',
      questions: [
        {
          id: '26',
          title: 'Location of the hydrant',
          description: 'Please mark the location of the hydrant on the map',
          type: SiteVisitQuestionType.map,
          category: SiteVisitQuestionCategoryType.hydrant,
          required: false,
          colors: {
            point: '#00b0eb',
            line: '#00b0eb',
            fill: '#00b0eb',
          },
          mapType: SiteVisitMapType.single,
        },
        //  {
        //   id: '27',
        //   title: 'Distance from closest fire hydrant to water meter',
        //   description: 'Mark points',
        //   type: SiteVisitQuestionType.map,
        //   category: SiteVisitQuestionCategoryType.hydrant,
        //   required: false,
        //   colors: {
        //     point: '#3a50b0',
        //     line: '#3a50b0',
        //     fill: '#d2d5d4',
        //   },
        //   mapType: SiteVisitMapType.line,
        // }
      ],
    },
    {
      id: '7',
      title: 'Driveway',
      description: 'Information about access and driveway',
      type: SiteVisitQuestionCategoryType.driveway,
      icon: 'car',
      questions: [
        {
          id: '28',
          title: 'Width of street',
          description: 'Mark points along the edges of the road',
          type: SiteVisitQuestionType.map,
          category: SiteVisitQuestionCategoryType.driveway,
          required: false,
          colors: {
            point: '##ffffe1',
            line: '##ffffe1',
            fill: '##ffffe1',
          },
          mapType: SiteVisitMapType.line,
        },
        {
          id: '29',
          title: 'Description of driveway (length, width)',
          description: '',
          type: SiteVisitQuestionType.text,
          category: SiteVisitQuestionCategoryType.driveway,
          required: true,
        },
        {
          id: '30',
          title: 'Potential crane locations',
          description: 'Mark the locations',
          type: SiteVisitQuestionType.map,
          category: SiteVisitQuestionCategoryType.driveway,
          required: false,
          colors: {
            point: '#ff532d',
            line: '#ff532d',
            fill: '#ff532d',
          },
          mapType: SiteVisitMapType.multiple,
        },
        {
          id: '31',
          title: 'Backyard access',
          description: 'enter width in feet and take photo',
          type: SiteVisitQuestionType.photos,
          category: SiteVisitQuestionCategoryType.driveway,
          required: true,
        },
        {
          id: '32',
          title: 'Material of the driveway',
          description: '',
          type: SiteVisitQuestionType.select,
          category: SiteVisitQuestionCategoryType.driveway,
          required: true,
          mode: SelectMode.single,
          options: ['Concrete', 'Pavers', 'Gravel', 'Other'],
        },
      ],
    },
    {
      id: '8',
      title: 'Documents',
      description: 'Required documents',
      type: SiteVisitQuestionCategoryType.documents,
      icon: 'file',
      questions: [
        // {
        //   id: '27',
        //   title: 'Property Address',
        //   type: SiteVisitQuestionType.text,
        //   category: SiteVisitQuestionCategoryType.documents,
        //   required: true,
        // },
        {
          id: '33',
          title: 'Site Plan',
          description: 'Upload file or share link',
          type: SiteVisitQuestionType.files,
          category: SiteVisitQuestionCategoryType.documents,
          required: true,
        },
        {
          id: '34',
          title: 'Boundary survey or civil/property line survey',
          description: 'Upload file or share link',
          type: SiteVisitQuestionType.files,
          category: SiteVisitQuestionCategoryType.documents,
          required: true,
        },
        {
          id: '35',
          title: 'Topographical survey or engineered drainage plan',
          description: 'Upload file or share link',
          type: SiteVisitQuestionType.files,
          category: SiteVisitQuestionCategoryType.documents,
          required: true,
        },
        {
          id: '36',
          title: 'Existing Geotechnical/ Soils Report',
          description: 'Upload file or share link',
          type: SiteVisitQuestionType.files,
          category: SiteVisitQuestionCategoryType.documents,
          required: true,
        },
        {
          id: '37',
          title: 'Title Report from when you purchased the property',
          description:
            'Part of the closing documents provided by the Title Company.\nUpload file or share link',
          type: SiteVisitQuestionType.files,
          category: SiteVisitQuestionCategoryType.documents,
          required: true,
        },
        {
          id: '38',
          title: 'Existing main house floor plan',
          type: SiteVisitQuestionType.files,
          category: SiteVisitQuestionCategoryType.documents,
          required: true,
        },
        {
          id: '39',
          title: "Owner's name",
          type: SiteVisitQuestionType.text,
          category: SiteVisitQuestionCategoryType.documents,
          required: true,
        },
      ],
    },
  ],
  createdAt: new Date(),
  updatedAt: new Date(),
};
